import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "output", "placeholder"];
  static values = {
    production: Boolean,
  };

  initialize() {
    window.submitInvisibleRecaptchaForm =
      this.submitInvisibleRecaptchaForm.bind(this);
  }

  submitInvisibleRecaptchaForm() {
    this.element.submit();
  }

  execute(ev) {
    if (this.productionValue) {
      ev.preventDefault();
      grecaptcha.execute();
    } else {
      this.element.submit();
    }
  }
}
